import axios from 'axios';
import get from 'lodash/get';
import moment from 'moment';
import qs from 'query-string';

// Libs
import { thunkHandler, thunkErrorHanlder } from '../../libs/utils';

// Constants
import { REMINDERS_BASE } from '../../constants/endpoints';

export const NEW_REMINDERS = 'NEW_REMINDERS';

export function getReminders(params) {
  if (typeof params !== "object" && !Array.isArray(params)) params = {};
  const qsObj = {};
  if (params.page) qsObj.page = params.page;
  if (params.start_date) {
    qsObj.start_date = params.start_date;
    if (params.end_date) qsObj.end_date = params.end_date;
    else qsObj.end_date = params.end_date = moment().format('YYYY-MM-DD');
  } // END if

  if (params.customer) qsObj.customer = params.customer
  return dispatch => axios.get(`${REMINDERS_BASE}?${qs.stringify(qsObj)}`)
    .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_REMINDERS, 'ERROR', res))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getReminders



// WEBPACK FOOTER //
// ./src/redux/actions/remindersActions.js